exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-modal-size-guide .sf-modal[data-v-3c4be5ef]{--modal-width: 700px}\n", ""]);

// exports
